import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

export interface UseGetDataExtractionParams {
	organization_id: string;
	company_id: string;
	data_extraction_id: string;
}

const Service = DataExtractionService.getInstance();

export const useGetDataExtraction = (params: UseGetDataExtractionParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION, params.data_extraction_id],
		queryFn: async () => Service.findOne(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.data_extraction_id
	});
};
